import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function homeFor(role) {
  if (role === "instrument_customer") return "/instrumentation/portal";
  if (role === "admin") return "/admin";
  if (role === "sales" || role === "sales_manager") return "/crm";
  return "/welcome";
}

export function ProtectedRoute({ children, role, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5]">
        <Loader2 className="h-6 w-6 animate-spin text-[#0F172A]" data-testid="auth-loading" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to={homeFor(user.role)} replace />;
  }
  return children;
}
